import { UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';
import { formatMoney } from '../../../../utils/string';
import { DiscountContainer } from '../Discount';
import * as styles from './Total.css';

interface ITotalProps {
  price: number;
}

export const Total = (props: ITotalProps) => {
  const { price } = props;

  return (
    <div className={styles['total']}>
      <UIHeading2 color="black_100">К оплате</UIHeading2>

      <div className={styles['dashed_line']} />

      <div className={styles['price_wrapper']}>
        <DiscountContainer />

        <UIHeading2 color="black_100">{formatMoney(price)}</UIHeading2>
      </div>
    </div>
  );
};
